import React from 'react';

class SelectOption extends React.Component {
  constructor(props) {
    super(props);
    this.selectId = 'select_' + this.props.id;
    this.selectMenuId = 'menu_' + this.props.id;
  }

  onOptionClick = (e, option) => {
    document.querySelector('#' + this.selectId).classList.remove('open');
    document.querySelector('#' + this.selectId + ' .dropdown-menu').setAttribute('aria-expanded', false);
    if (this.props.onOptionClickHandler) {
      this.props.onOptionClickHandler(option);
    }
  }

  onClickHandler = (e) => {
    const target = e.target;
    const parent = document.querySelector('#' + this.selectId);

    const expanded = parent.classList.contains('open');
    // parent.classList.map((classname) => {
    //   if (classname === 'open') {
    //     expanded = true;
    //   }
    //   return undefined;
    // });

    if (expanded) {
      target.setAttribute('aria-expanded', false);
      parent.classList.remove('open');
    } else {
      target.setAttribute('aria-expanded', true);
      parent.classList.add('open');
    }
  }

  render() {
    const options = this.props.list;
    const dropdownmenustyle = {
      top: 'auto',
      bottom: '100%',
      'margin-bottom': '2px',
      // left: '25%',
    };
    const dropdownstyle = {
      // top: 'auto',
      // bottom: '100%',
      // 'margin-bottom': '2px',
      // left: '25%',
      display: 'inline-block',
    };
    return (
      <React.Fragment>
        {/* <style type="text/css">
          .dropdown-toggle:before {

          }
        </style> */}
        <div className="dropdown dropup" id={this.selectId} style={dropdownstyle}>
          <ul className={'dropdown-menu ' + this.props.className} aria-labelledby={this.selectMenuId} style={dropdownmenustyle}>
            {options.map((opt, key) => {
              if (opt.isEnabled === true) { return <li key={key} className="option" data-value={opt.value} data-text={opt.text}><a onClick={(e) => { this.onOptionClick(e, opt); }}>{opt.text}</a></li>; }
              return <li key={key} className="option-disable">{opt.text}</li>;
            })}
          </ul>
          <span className={'dropdown-toggle ' + this.props.captionClass} type="button" data-toggle="dropdown" onClick={(e) => { this.onClickHandler(e); }} id={this.selectMenuId}>
            {/* {this.getSelectedOptionByValue()} */}
            {this.props.selectCaption}
            <span className="caret" />
          </span>
        </div>
      </React.Fragment>
    );
  }
}

export default SelectOption;
